// extracted by mini-css-extract-plugin
module.exports = {"variables":"'../../../../../variables.css'","--ds-color-cloudVeil":"#f6f8f8","button":"cta-button_button__YcyOb"};